import { DataTableDefinition } from "@/v2/types/Datatable";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, Pencil } from "lucide-react";
import { generateFilterColumn } from "../../filter";
import { TermsAndCondition } from "@/v2/types";
import TermsAndConditionsDeleteButton from "../../ui/button/delete/TermsAndCondition";

type T = TermsAndCondition;

const columnHelper = createColumnHelper<T>();

const TermsAndConditionsColumnDefinition: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "template_name",
        headingText: "Template Name",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2 text-black">
                    <Link to={`/templates/terms-and-conditions/${row.id}`}>
                        <Button size={"sm"} variant={"outline"}>
                            <Eye className="h-4 w-4" />
                        </Button>
                    </Link>

                    <Link to={`/templates/terms-and-conditions/edit/${row.id}`}>
                        <Button size={"sm"} variant={"outline"}>
                            <Pencil className="h-4 w-4" />
                        </Button>
                    </Link>
                    <TermsAndConditionsDeleteButton id={row.id} />
                </div>,
                {},
            ),
    },
];

const TermsAndConditionsColumn = buildColumns<T>(
    columnHelper,
    TermsAndConditionsColumnDefinition,
);

const TermsAndConditionFilterColumn = generateFilterColumn<T>(
    TermsAndConditionsColumnDefinition,
);

export { TermsAndConditionsColumn, TermsAndConditionFilterColumn };
